<template>
  <section id="service" class="service-prices">
    <div class="service-prices__content">
      <h2 class="title__section">Услуги и стоимость</h2>

      <div class="service-prices__list">
        <article
          v-for="service in services"
          :key="service.title"
          class="service-prices__item"
        >
          <h3 class="service-prices__title">{{ service.title }}</h3>
          <p class="service-prices__price">{{ service.price }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Service',
  data() {
    return {
      services: [
        {
          title: 'Разработка интернет-магазина',
          price: 'От 500,000р'
        },
        {
          title: 'Разработка корпоративного сайта',
          price: 'От 400,000р'
        },
        {
          title: 'Интеграция с 1С',
          price: 'От 200,000р'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.service-prices {
  color: #0E0252;

  &__content {
    max-width: 1816px;
    margin: 80px auto 60px;
    padding: 0 20px;

    @media (max-width: 1920px) {
      @include adaptive-value("margin", 80 30, auto, 60 30, auto);
    }
  }

  &__list {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 24px;

    @media (max-width: 1200px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 680px) {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }

  &__item {
    min-height: 230px;
    padding: 32px;
    border-top: 4px solid #88BA4A;
    background: #F5F4F8;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: 976px) {
      min-height: 200px;
      padding: 24px;
    }

    @media (max-width: 680px) {
      min-height: 170px;
    }
  }

  &__title {
    max-width: 420px;
    margin: 0 0 32px;
    font-size: 25px;
    font-weight: 600;
    line-height: 1.35;

    @media (max-width: 1920px) {
      @include adaptiv-fontAll(25, 18);
    }
  }

  &__price {
    margin: 0;
    color: #88BA4A;
    font-size: 25px;
    font-weight: 600;
    line-height: 1.35;

    @media (max-width: 1920px) {
      @include adaptiv-fontAll(25, 18);
    }
  }
}
</style>
